<template>
    <div class="ad-item card-item">
        <div class="ad-img" style="transform:scale(0.7);transform-origin: 0px 0px;">
            <div :class="['loyalty-ad-container',{ rotate: rotated }]">
                <div class="front-box" style="position: relative;" :style="{ height: card.height+'px', backgroundColor: card.frontBackgroundColor, fontColor: card.frontFontColor }">  

                    <img class="loyalty-ad" :src="card.src" style="position: relative" />

                    <div class="page-state-btns">
                        <!-- <p class="page-state-btns-btn issued" v-if="card.issued > 0">{{ card.issued }}</p> -->
                        <!-- <p class="page-state-btns-btn redeemed" v-if="card.redeemed > 0">{{ card.redeemed }}</p> -->
                        <p v-if="!noedit" class="page-state-btns-btn edit" @click="$router.push('/carddesigner/'+card._id)">edit</p>
                        <!-- <p class="page-state-btns-btn remove" @click="$emit('removeCard',card)">remove</p> -->
                    </div>
                    <div class="page-state-btns expiry-btns" @click="$emit('setExpiry',card)">
                        <p class="page-state-btns-btn set-expires" v-if="card.expireAd && !card.expires">SET EXIPRY DATE</p>
                        <p class="page-state-btns-btn expires" v-if="card.expires > 0" :style="{ backgroundColor: card.expires < Date.now() ? 'red' : 'green' }">{{ card.expires > 0 ? format(card.expires,'dd/MM/yyy') : '' }}</p>
                    </div>

                    <div class="btns">
                        <div @click="clickBtn(btn)" v-for="(btn,i) in card.btns.filter(b => !b.reverse)" :key="i">
                            <component :is="btn.component" :btn="btn" class="ad-btn" :live="true" :style="btn.style"></component>
                        </div> 
                    </div>

                </div>
                <div class="back-box" :style="{ height: card.height+'px',backgroundColor: card.backBackgroundColor, fontColor: card.backFontColor }">
                    <img class="loyalty-ad" :src="card.backface" />
                    <div class="btns">
                        <div @click="clickBtn(btn)" v-for="(btn,i) in card.btns.filter(b => b.reverse)" :key="i">
                            <component :is="btn.component" :btn="btn" class="ad-btn" :live="true" :style="btn.style"></component>
                        </div> 
                    </div>    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CComp from '../components/Cards/Comp';
import CImage from '../components/Cards/Image'
import CLink from '../components/Cards/Link';
import CQr from '../components/Cards/Qr'
import CRotate from '../components/Cards/Rotate'
import CTerms from '../components/Cards/Terms'
import CText from '../components/Cards/Text'
import CVideo from '../components/Cards/Video';
import CButton from '../components/Cards/Button.vue'
import CBox from '../components/Cards/Box'

import { format } from 'date-fns'

export default {
    props: ['card','wallet','noedit'],
    components: {
        CComp,
        CImage,
        CLink,
        CQr,
        CRotate,
        CTerms,
        CText,
        CVideo,
        CButton,
        CBox
    },
    mounted () {
        console.log('mounted Card.vue',this.$el);
        console.log('this.card',this.card);
    },
    data () {
        return {
            format,
            rotated: false
        }
    },
    methods: {
        clickBtn ( btn ) {
            console.log('btnClick btn',btn);
            console.log('btn.action',btn.action);
            switch ( btn.action ) {
                case 'rotate':
                    this.rotated = !this.rotated;
                    break;
            }
            if ( btn.action ) return;
            switch ( btn.type ) {
                case 'rotate':
                    this.rotated = !this.rotated;
                    break;
            }
        }
    }
}

</script>

<style lang="scss">
.card-item {
    .ad-btn {
        display: flex;
        /* align-items: center; */
        justify-content: space-around;
        position: absolute;
    }
    .ad-img {
        width: 414px;
        padding-right: 10px;
        transform: scale(1) !important;
        &:last-child { margin-bottom: 10px }
        div.loyalty-ad-container {
            width: 100%;
            margin: 5px;
        }
    }
}    
.reward-img {
    position: absolute;
    left: -50px;
    top: 55px;
    transform: scale(0.55);
    border-left: 50px solid white;
    border-right: 50px solid white;
    background-color: white;
}    
.page-state-btns {
    position: absolute;
    top: -35px;
    left: 330px;
    &.expiry-btns {
        top: 0px;
        right: 0px;
        p.page-state-btns-btn {
            z-index: 20;
            &.set-expires {
                background-color: red;
                position: absolute;
                top: 0px;
                right: 10px; 
                color: white;
                padding: 2px 15px;              
            }
            &.expires {
                background-color: green;
                position: absolute;
                top: 0px;
                right: 10px; 
                color: white;
                padding: 2px 15px;    
            }

        }
    }
    p.page-state-btns-btn {
        position: relative;
        border-top-left-radius: 5px;
        padding: 0px 3px;
        border-top-right-radius: 5px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;
        min-width: 40px;
        margin-left: 10px;
        color: white;
        margin-top: 10px;
        font-size: 20px;
        z-index: 20;
        &.edit {
            background-color: #007bc8;
            padding: 3px 10px;
            width: 60px;
            line-height: 20px;
            font-size: 16px;
        }
        &.remove {
            position: absolute;
            background-color: red;
            left: 312px;
            width: 75px;
            line-height: 33px;
            top: -15px;
        }
        &.issued {
            background-color: green; /* #00D000; */
            color: white;
            font-size: 24px;
            min-width: 60px;
            z-index: 20;
        }
        &.redeemed {
            background-color: tomato; /* #c23c24; */
            color: black;
            min-width: 60px;
        }
    }
}
div.loyalty-ad-container {
    position: relative;
    transition: transform 1s;
    -webkit-perspective: 1000;
    transform-style: preserve-3d;
    perspective: 1000;
    -webkit-transform:translate3d(0,0,0);
    float: left;
    width: calc(100% - 10px);
    margin: 5px 0px 0px 5px;
    img.sizer {
        width: 100%;
        margin: 0px;
        z-index: -1;
        opacity: 0;
    }
    .front-box,.back-box {
        float: left;
        opacity: 1;
        position: absolute;
        width: 100%;
        margin: 0px;
        top: 0px;
        left: 0px;
        backface-visibility: hidden;
        -webkit-transform:translate3d(0,0,0);
        transform-style: preserve-3d;
        perspective: 1000;
    }
    .front-box {
        z-index: 2;
    }
    .back-box {
        z-index: 1;
        transform: rotateY(180deg);
        position: absolute;
        left: 0px;
    }
    &.rotate {
        transform: rotateY(180deg);
    }
    img.loyalty-ad {
        width: 100%;
        position: absolute;
    }
    .btns {
        position: absolute;
        top: 0px;
        left: 0px;
        transform-origin: 0px 0px;
        border: 0px;
        .btn { position: absolute; background-color: rgba(200,0,200,0); &:active { transform: translate(0px,0px) } }
        .type-qr img { width: 100%; }
        .type-link a { position: absolute; width: 100%; height: 100%; }
    }
}    
.ad-img {
    width: 414px;
    margin: 10px;
    float: left;
    position: relative;
    /* border: 1px solid #c0c0c0;
    &:last-child { margin-bottom: 100px; } */
    img { width: 100%; }
    .btns {
        position: absolute;
        width: 100%;
        bottom: 0px;
        background-color: white;
        color: red;
        background-color: rgba(200,200,200,0);
        p { width: 50%; height: 120px; background-color: rgba(200,0,0,0); float: left; margin: 0px; top: 0px; }
    }
    p { position: relative; top: -15px; }
    p:last-child { margin-bottom: -3px; }
}
</style>